<script setup>
import { onMounted } from "vue";
import { useGlobalStore } from "@stores/global";
import Clips from "@components/explore/Clips.vue";
import CountryInfo from "@components/explore/CountryInfo.vue";
import Countdown from "@components/explore/Countdown.vue";
import FeaturedActivities from "@components/explore/FeaturedActivities.vue";
import ToggleControls from "@components/explore/ToggleControls.vue";
import BehindTheScenes from "@components/explore/BehindTheScenes.vue";

const globalStore = useGlobalStore();

onMounted(() => {
    // Show the "Shop the Shoot" intro only until it's been seen/closed.
    if (globalStore.exploreIntroSeen) return;
    globalStore.openModal("exploreIntro", { bare: true });
});
</script>

<template>
    <div class="contents">
        <Clips />
        <CountryInfo />
        <Countdown />
        <FeaturedActivities />
        <ToggleControls />
        <BehindTheScenes />
    </div>
</template>
